//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"FeatureFilter",1,0],[0,"Name",1,0],[1,"SelectFeatures",0,"SelectNXObjectList",0]],[[["nSubFeatures"],"GetSubFeatures",{R_:{subFeatures:""}},0,0],[["subFeatures"],"SetSubFeatures",{},1,0]],[]];
SPLM.CAM.InspectionPatternFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionPatternFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionPatternFeatureBuilder.FeatureFilterTypes = Object.freeze({
    "None" : "None", "Points" : "Points", "Lines" : "Lines", "Planes" : "Planes", "Curves" : "Curves", "Holes" : "Holes", "Pins" : "Pins", "Spheres" : "Spheres", "Surfaces" : "Surfaces"});

export default SPLM;